import {
  addRequestInterceptor,
  addResponseInterceptor,
  addRequestInterceptorForOwner,
  addResponseInterceptorForOwner,
} from '../client';
import { requestWithAuth, handleAuthError } from './auth';
import { requestCamelToSnake, responseSnakeToCamel } from './formatting';
import { handleError } from './error';

export default function initializeHttpInterceptors() {
  addRequestInterceptor({ request: requestWithAuth });
  addRequestInterceptorForOwner({ request: requestWithAuth });
  addResponseInterceptor({ error: handleAuthError });
  addResponseInterceptorForOwner({ error: handleAuthError });
  addRequestInterceptor({ request: requestCamelToSnake });
  addRequestInterceptorForOwner({ request: requestCamelToSnake });
  addResponseInterceptor({ response: responseSnakeToCamel });
  addResponseInterceptorForOwner({ response: responseSnakeToCamel });
  addResponseInterceptor({ error: handleError });
  addResponseInterceptorForOwner({ error: handleError });
}
